export const SET_PING = 'SET_PING';
export const SET_EXCHANGES = 'SET_EXCHANGES';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_ASSOCIATIONS_STATES = 'SET_ASSOCIATIONS_STATES';
export const SET_POINTS_OF_SALE_CATEGORIES = 'SET_POINTS_OF_SALE_CATEGORIES';
export const SET_IS_LOADING_POINTS_OF_SALE_CATEGORIES = 'SET_IS_LOADING_POINTS_OF_SALE_CATEGORIES';
